import RedirectToHome from './RedirectToHome';

export default {
  list: RedirectToHome,
  show: RedirectToHome,
  edit: RedirectToHome,
  create: RedirectToHome,
};
